import { Component, OnInit, HostBinding } from '@angular/core';
import { Title } from '@angular/platform-browser';

@Component({
  selector: 'app-us',
  templateUrl: './us.component.html',
  styleUrls: ['./us.component.scss']
})
export class UsComponent implements OnInit {
  @HostBinding('class') hostClasses = 'hero';

  constructor(private title: Title) { }

  ngOnInit() {
    this.title.setTitle('Nosotros - CCCISA');
  }

}
